/** @type {import('./$types').LayoutLoad} */

export const load = async ({ url, data }) => {
    const { pathname } = url; // Can resolve client side to stop waterfall from server

    const cartOpen = url?.searchParams?.get('cartOpen');

    return {
        ...data, // Fetch/Cache server response
        pathname,
        cartOpen
    };
};
